export default function BlockIllustration(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={277}
      height={200}
      fill="none"
      viewBox="0 0 800 578"
      {...props}
    >
      <path
        stroke="#D6D6D6"
        strokeWidth={17.778}
        d="M244.453 66.668h311.111M244.453 111.105h193.333M244.453 422.227h311.111M244.453 511.117h311.111M244.453 466.672h257.778"
      />
      <rect
        width={402.747}
        height={222.222}
        x={198.633}
        y={155.559}
        fill="#52E3AC"
        rx={22.222}
      />
    </svg>
  );
}
